// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 761 ? "d0deef33" : chunkId) + "." + {"423":"2b74c0ea39d55d58","761":"1a57be0f3bc71bbb"}[chunkId] + ".js";
};